import { RequestBuilder } from '@cvent/nucleus-networking';
import Logger from '@cvent/nucleus-logging';
import { fetchAndRetryIfServerBusy } from '../utils/wrappedFetchAndRetryIfServerTooBusy';
import { ServiceError } from 'event-widgets/utils/errors';

const LOG = new Logger('PasskeyClient');

/**
 * The passkey client
 */
export default class PasskeyClient {
  passkeyBasUrl;
  environment;
  request;
  constructor(baseURL, eventId, environment) {
    this.environment = environment;
    this.passkeyBasUrl = baseURL + 'passkey/v1/redirect-uri';
    this.passkeyRequest = new RequestBuilder({ url: this.passkeyBasUrl }).withCookies();
    this.passkeyRequest = this.passkeyRequest.header('Cvent-Event-ID', eventId);
  }

  /**
   * Fetch passkey hotel request redirect url
   * @param authToken auth token to use for the request
   * @param inviteeId to get id corresponding to which passkey request need to be populated
   * @returns {Promise<*>}
   */
  async getNewRequestRedirectUrl(authToken, inviteeId) {
    const request = this.passkeyRequest
      .url(`${this.passkeyBasUrl}/create-reservation/${inviteeId}`)
      .query('environment', this.environment)
      .post()
      .auth(authToken)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      const error = await ServiceError.create('Error getting passkey new hotel request url', response, request);
      LOG.info('Error getting passkey new hotel request url ', request.url, error.responseStatus, error.responseBody);
      throw error;
    }
    return await response.json();
  }

  /**
   * Fetch passkey hotel request redirect url
   * @param authToken auth token to use for the request
   * @param hotelReservationId hotel reservation id for which the redirect url is to be created
   * @returns {Promise<*>}
   */
  async getEditRequestRedirectUrl(authToken, hotelReservationId) {
    const request = this.passkeyRequest
      .url(`${this.passkeyBasUrl}/reservations/${hotelReservationId}`)
      .query('environment', this.environment)
      .get()
      .auth(authToken)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      const error = await ServiceError.create('Error getting passkey edit hotel request url', response, request);
      LOG.info('Error getting passkey edit hotel request url ', request.url, error.responseStatus, error.responseBody);
      throw error;
    }
    return await response.json();
  }
}
